import { useAppState } from '../hooks/zustandHooks';
import { userIdStorage } from '../domain/services';

const ZENDESK_BASE = 'https://support.atto.co/hc/en-us/requests/new?ticket_form_id=8774557661332';
const SUPPORT_EMAIL = 'support@atto.co';

function buildSupportBody(errorCode?: string, separator = '\n'): string {
    const { clientId, configurationId, customerReference, consentId } = useAppState.getState().appState;
    const userId = userIdStorage.getUserId();

    const lines: string[] = [];

    if (clientId)           lines.push(`App ID: ${clientId}`);
    if (configurationId)    lines.push(`Config ID: ${configurationId}`);
    if (customerReference)  lines.push(`Customer Ref: ${customerReference}`);
    if (consentId)          lines.push(`Consent ID: ${consentId}`);
    if (userId)             lines.push(`User ID: ${userId}`);
    if (errorCode)          lines.push(`Error Code: ${errorCode}`);

    if (lines.length === 0) return '';

    lines.unshift(`${separator+separator} -- information captured from user session, please do not change or remove --`);
    return lines.join(separator + ' ');
}

export function buildZendeskSupportUrl(errorCode?: string): string {
    const body = buildSupportBody(errorCode, '<br>');
    return `${ZENDESK_BASE}&tf_description=${encodeURIComponent(body)}`;
}

export function buildMailtoSupportUrl(subject: string, errorCode?: string): string {
    const body = buildSupportBody(errorCode, '\n');
    return `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}

